import { createAction, props } from '@ngrx/store';
import { DocumentTypeLevel } from 'src/app/compliance/enums/document-type-level.enum';
import { Lookup } from 'src/app/shared/models/lookup.model';
import { CandidateVendorTestCodeDto } from '../../api/models/candidate-vendor-test-code-dto.model';
import { ComplianceLabRequestDocumentTypeConfigurationDto } from '../../api/models/compliance-lab-request-document-type-configuration-dto.model';

export const getDsHasDocumentTypeConfiguration = createAction(
    '[COMPLIANCE LAB REQUESTS] Get DS Has Document Type Configuration',
    props<{
        documentTypeLevel: DocumentTypeLevel;
        entityId: number;
    }>()
);

export const updateDsHasDocumentTypeConfigurationOnSubmit = createAction(
    '[COMPLIANCE LAB REQUESTS COMPONENT] Update Ds Has Document Type Configuration On Submit',
    props<{ result: number[] }>()
);

export const getDsHasDocumentTypeConfigurationSuccess = createAction(
    '[COMPLIANCE LAB REQUESTS] Get DS Has Document Type Configuration Success',
    props<{ result: number[] }>()
);

export const getDsHasDocumentTypeConfigurationFailure = createAction(
    '[COMPLIANCE LAB REQUESTS] Get DS Has Document Type Configuration Failure',
    props<{ error: unknown }>()
);

export const getLabVendors = createAction('[COMPLIANCE LAB REQUESTS] Get Current Lab Vendors');

export const getLabVendorsSuccess = createAction(
    '[COMPLIANCE LAB REQUESTS] Get Current Lab Vendors Success',
    props<{ result: Lookup[] }>()
);

export const getLabVendorsFailure = createAction(
    '[COMPLIANCE LAB REQUESTS] Get Current Lab Vendors Failure',
    props<{ error: unknown }>()
);

export const getDsDocumentTypeIds = createAction('[COMPLIANCE LAB REQUESTS] Get Ds Document Type Ids');

export const getDsDocumentTypeIdsSuccess = createAction(
    '[COMPLIANCE LAB REQUESTS] Get Ds Document Type Ids Success',
    props<{ result: number[] }>()
);

export const getDsDocumentTypeIdsFailure = createAction(
    '[COMPLIANCE LAB REQUESTS] Get Ds Document Type Ids Failure',
    props<{ error: unknown }>()
);

export const getLabRequestDocumentTypeConfiguration = createAction(
    '[COMPLIANCE LAB REQUESTS] Get Document Type Configuration',
    props<{ documentTypeId: number; documentTypeLevelType: number; levelId: number }>()
);

export const getLabRequestDocumentTypeConfigurationSuccess = createAction(
    '[COMPLIANCE LAB REQUESTS] Get Document Type Configuration Success',
    props<{ result: ComplianceLabRequestDocumentTypeConfigurationDto }>()
);

export const getLabRequestDocumentTypeConfigurationFailure = createAction(
    '[COMPLIANCE LAB REQUESTS] Get Document Type Configuration Failure',
    props<{ error: unknown }>()
);

export const addLabRequestDocumentTypeConfiguration = createAction(
    '[COMPLIANCE LAB REQUESTS] Add Document Type Configuration',
    props<{ configuration: ComplianceLabRequestDocumentTypeConfigurationDto }>()
);

export const addLabRequestDocumentTypeConfigurationSuccess = createAction(
    '[COMPLIANCE LAB REQUESTS] Add Document Type Configuration Success'
);

export const addLabRequestDocumentTypeConfigurationFailure = createAction(
    '[COMPLIANCE LAB REQUESTS] Add Document Type Configuration Failure',
    props<{ error: unknown }>()
);

export const updateLabRequestDocumentTypeConfiguration = createAction(
    '[COMPLIANCE LAB REQUESTS] Update Document Type Configuration',
    props<{ documentTypeId: number; configuration: ComplianceLabRequestDocumentTypeConfigurationDto }>()
);

export const updateLabRequestDocumentTypeConfigurationSuccess = createAction(
    '[COMPLIANCE LAB REQUESTS] Update Document Type Configuration Success'
);

export const updateLabRequestDocumentTypeConfigurationFailure = createAction(
    '[COMPLIANCE LAB REQUESTS] Update Document Type Configuration Failure',
    props<{ error: unknown }>()
);

export const getCandidateVendorTestCodes = createAction(
    '[COMPLIANCE LAB REQUESTS] Get Candidate Vendor Test Codes',
    props<{ candidateId: number }>()
);

export const getCandidateVendorTestCodesSuccess = createAction(
    '[COMPLIANCE LAB REQUESTS] Get Candidate Vendor Test Codes Success',
    props<{ testCodes: CandidateVendorTestCodeDto[] }>()
);

export const getCandidateVendorTestCodesFailure = createAction(
    '[COMPLIANCE LAB REQUESTS] Get Candidate Vendor Test Codes Failure',
    props<{ error: unknown }>()
);
